import React, { Component, CSSProperties } from 'react'
import { inject, observer } from 'mobx-react'
import CKEditor from '@ckeditor/ckeditor5-react'
import CKEditorInline from '@ckeditor/ckeditor5-build-inline'
import { Modal, Button, Input, Icon, Popconfirm, Select, Alert, Layout, Row, Col } from 'antd'
import ServicesList from './ServicesList'
import SubscriptionsList from './SubscriptionsList'
import { couponUnits } from '@texts/coupons'

@inject((store: any) => {
    const { popupStore, couponTypesStore, servicesStore } = store
    return { popupStore, couponTypesStore, servicesStore }
})
@observer
export default class CouponTypePopup extends Component<any, any> {
    state: any = {
        errors: {}
    }

    closePopup = () => {
        this.setState({ errors: {}, prevValues: {} })
        this.props.popupStore.togglePopup(false)
    }

    validateCouponType = () => {
        const { name, discount, units } = this.props.couponTypesStore.editCouponType
        const errors = {}
        if (!name) errors['name'] = 'חובה להזין שם סוג קופון'
        if (!discount) errors['discount'] = 'חובה להזין סכום להנחה'
        if (!units) errors['units'] = 'עליך לבחור יחידות על פיהן תחושב ההנחה'
        if (units === 'PERCENT' && discount > 100) errors['discount'] = 'הנחה באחוזים אינה יכולה לעבור 100%'
        this.setState({ errors })
    }

    handleSubmit = async () => {
        await this.validateCouponType()
        if (!Object.keys(this.state.errors).length) {
            const { submitCouponType, getList } = this.props.couponTypesStore
            const coupon = await submitCouponType()
            if ('error' in coupon) {
                this.setState({ errors: { serverError: 'שגיאת שרת בעדכון סוג הקופון' } })
            } else {
                await getList()
                this.closePopup()
            }
        }
    }

    handleChangeCharges = value => {
        const {
            couponTypesStore: { changeEditValue }
        } = this.props
        changeEditValue('subscriptions', null)
        changeEditValue('services', null)
        changeEditValue('iteration_charge', value)
    }

    handleDeleteCouponType = async () => {
        const { deleteCouponType, getList } = this.props.couponTypesStore
        const coupon = await deleteCouponType()
        if ('error' in coupon) {
            this.setState({ errors: { serverError: 'שגיאת שרת במחיקת סוג קופון' } })
        } else {
            await getList()
            this.closePopup()
        }
    }

    render() {
        const {
            popupStore: { popupType },
            couponTypesStore: {
                loading,
                changeEditValue,
                editCouponType: {
                    description,
                    iteration_charge,
                    name,
                    id,
                    discount,
                    min_price,
                    max_discount,
                    units,
                    __meta__
                }
            }
        } = this.props
        const { errors } = this.state
        const errorStyle: CSSProperties = { fontWeight: 'bold', color: 'red' }
        const isMonthsCoupon = units === 'MONTHS'
        const sumLabel = isMonthsCoupon ? 'כמות חודשים' : 'סכום ההנחה'

        console.log(units, 'from couponTypePopup')
        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>ביטול</Button>
                <Popconfirm
                    title="האם ברצונך לשמור את השינויים?"
                    okText="אישור"
                    cancelText="ביטול"
                    onConfirm={() => this.handleSubmit()}
                >
                    <Button type="primary" disabled={loading}>
                        {loading ? <Icon type="loading" /> : ''}
                        {id ? 'שמור את השינויים' : 'הוסף סוג קופון'}
                    </Button>
                </Popconfirm>
                {id && __meta__.total_coupons === 0 && (
                    <Popconfirm
                        title="האם למחוק סוג קופון זה?"
                        okText="אישור"
                        cancelText="ביטול"
                        onConfirm={() => this.handleDeleteCouponType()}
                    >
                        <Button style={{ float: 'left' }} type="danger" disabled={loading}>
                            {loading ? <Icon type="loading" /> : ''}
                            מחק סוג קופון
                        </Button>
                    </Popconfirm>
                )}
            </div>
        )
        return (
            <Modal
                title={id ? `עריכת סוג קופון ${name}(${id})` : 'הוסף סוג קופון חדש'}
                visible={popupType === 'couponType'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={1000}
            >
                {'serverError' in errors && <Alert type="error" message={errors['serverError']} />}
                <div>
                    <label style={{ fontSize: '1rem' }}>
                        <strong>שם סוג הקופון</strong>
                    </label>
                    <Input
                        value={name}
                        placeholder="הזן שם סוג הקופון"
                        onChange={e => changeEditValue('name', e.target.value)}
                    />
                    <div style={errorStyle}>{'name' in errors && errors['name']}</div>
                </div>
                <div>
                    <label style={{ fontSize: '1rem' }}>
                        <strong>תיאור הקופון</strong>
                    </label>
                    <div style={{ border: '1px solid #d4d4d4', borderRadius: '5px', marginBottom: '1rem' }}>
                        <CKEditor
                            data={!!description ? description : ''}
                            editor={CKEditorInline}
                            onChange={(event, editor) => {
                                const data = editor.getData()
                                changeEditValue('description', data)
                            }}
                            config={{
                                language: 'he',
                                toolbar: [
                                    'heading',
                                    '|',
                                    'bold',
                                    'italic',
                                    'link',
                                    'bulletedList',
                                    'numberedList',
                                    'blockQuote',
                                    'insertTable',
                                    'undo',
                                    'redo'
                                ]
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: '1rem', width: '50%' }}>
                        <label style={{ fontSize: '1rem' }}>
                            <strong>{sumLabel}</strong>
                        </label>
                        <div style={{ width: '100%' }}>
                            <Input
                                type="number"
                                style={{ width: '70%' }}
                                min={0}
                                value={discount}
                                onChange={e => changeEditValue('discount', e.target.value)}
                            />
                            <Select
                                placeholder="יח׳"
                                style={{ width: '30%', textAlign: 'right', direction: 'rtl' }}
                                value={units}
                                onChange={e => changeEditValue('units', e)}
                            >
                                {Object.keys(couponUnits).map(key => (
                                    <Select.Option key={key} value={key}>
                                        {couponUnits[key]}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                        <div style={errorStyle}>{'discount' in errors && errors['discount']}</div>
                        <div style={errorStyle}>{'units' in errors && errors['units']}</div>
                    </div>
                    <div style={{ marginLeft: '1rem' }}>
                        <label style={{ fontSize: '1rem' }}>
                            <strong>סכום מינימלי לאחר הנחה</strong>
                        </label>
                        <Input
                            type="number"
                            min={0}
                            value={min_price}
                            disabled={isMonthsCoupon}
                            onChange={e => {
                                const value = e.target.value ? e.target.value : '0'
                                changeEditValue('min_price', value)
                            }}
                        />
                    </div>
                    <div style={{ marginLeft: '1rem' }}>
                        <label style={{ fontSize: '1rem' }}>
                            <strong>הנחה מקסימלית</strong>
                        </label>
                        <Input
                            type="number"
                            min={0}
                            value={max_discount}
                            disabled={isMonthsCoupon}
                            onChange={e => {
                                const value = e.target.value ? e.target.value : '0'
                                changeEditValue('max_discount', value)
                            }}
                        />
                    </div>
                    <div>
                        <label style={{ fontSize: '1rem' }}>
                            <strong>מס׳ חודשים בחיוב חוזר</strong>
                        </label>
                        <Input
                            disabled={true}
                            type="number"
                            min={0}
                            value={iteration_charge}
                            onChange={e => this.handleChangeCharges(e.target.value)}
                        />
                    </div>
                </div>
                <div>
                    <label style={{ fontSize: '1rem', marginTop: '1rem' }}>
                        <strong>שירותים עליהם תחול ההנחה</strong>
                    </label>
                    <Layout style={{ backgroundColor: 'white' }}>
                        <Row gutter={2}>
                            <Col xs={12} style={{ padding: '0 0 0 0.5rem' }}>
                                <ServicesList />
                            </Col>
                            <Col xs={12} style={{ padding: '0 0.5rem 0 0' }}>
                                <SubscriptionsList />
                            </Col>
                        </Row>
                    </Layout>
                </div>
            </Modal>
        )
    }
}
